import React, { useState, useEffect } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PaymentForm from './PaymentForm';
import { api } from '../apiClient';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const CheckoutForm = ({ mockupId, quantity, totalAmount, currency, shippingAddress }) => {
  const [clientSecret, setClientSecret] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const fetchClientSecret = async () => {
      try {
        const response = await api.post('/create-payment-intent', {
          mockup_id: mockupId,
          quantity: quantity,
          total_amount: totalAmount,
          currency: currency,
          shipping_address: shippingAddress,
        });
        setClientSecret(response.data.clientSecret);
        setOrderId(response.data.orderId);
      } catch (err) {
        console.error('Error fetching client secret:', err);
        setMessage(`Failed to load payment: ${err.response?.data?.detail || err.message}`);
      }
    };

    fetchClientSecret();
  }, [mockupId, quantity, totalAmount, currency, shippingAddress]);

  const appearance = {
    theme: 'stripe',
  };

  const options = {
    clientSecret,
    appearance,
  };

  return (
    <>
      {clientSecret && (
        <Elements stripe={stripePromise} options={options}>
          <PaymentForm orderId={orderId} />
        </Elements>
      )}
      {message && <div id="payment-message" className="text-red-500">{message}</div>}
    </>
  );
}

export default CheckoutForm;

